<template>
  <div class="mt-6 quarter-dropdown">
    <div @click="() => openCloseDropdown()" class="mb-4">
      {{ dropdownLabel }}
      <Icon
        :key="showDropdown"
        :name="showDropdown ? 'chevron-down' : 'chevron-up'"
        style="transform: scale(0.6)"
      />
    </div>
    <CCol col="12" v-if="showDropdown">
      <CRow v-for="quartersRow in quarterListInRows" class="mt-3">
        <template
          v-for="quarter in quartersRow"
          :key="`${quarter.id}-${quarter.is_active}`"
        >
          <div
            class="quarter-card"
            :class="quarter.is_active ? 'active' : 'disabled'"
          >
            <CLink :to="`/closing-file/${quarter.name}`">
              <CRow style="height: 50%" class="ml-2">
                <CCol col="12" class="h-50">
                  <h5 class="mt-4 font-weight-bold text-capitalize">
                    {{ (quarter.display_name || quarter.label || quarter.name).replaceAll("_", ' ') }}
                  </h5>
                </CCol>
              </CRow>
              <CRow style="height: 50%" class="ml-2">
                <CCol col="6" class="h-50 mt-4">
                  <span class="card-label">
                    <span
                      class="dot mr-1"
                      :class="quarter.is_active ? 'active' : 'completed'"
                    />
                    {{ dropdownLabel }}
                  </span>
                </CCol>
                <div
                  class="h-50 mt-4 card-label w-50"
                  style="padding-right: 25px"
                >
                  {{ getLastUpdatedLabel(quarter.last_update_date) }}
                </div>
              </CRow>
            </CLink>
          </div>
        </template>
      </CRow>
    </CCol>
  </div>
</template>

<script>
export default {
  name: "CardDropdownList",
  props: {
    initShowDropdown: {
      type: Boolean,
      default: true,
    },
    quarterListInRows: {
      type: Array,
      default: [],
    },
    dropdownLabel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDropdown: true,
    };
  },
  mounted() {
    this.showDropdown = this.initShowDropdown;
  },
  methods: {
    openCloseDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    getLastUpdatedLabel(lastUpdateDate){
      const oneDay = 24 * 60 * 60 * 1000;
      let diffDays = Math.round(Math.abs((Date.now() - Date.parse(lastUpdateDate)) / oneDay));
      let daysOrMonths = 'days';

      if (diffDays > 365) {
        diffDays /= 365;
        daysOrMonths = 'years'
      } else if (diffDays > 31) {
        diffDays /= 30;
        daysOrMonths = 'months'
      }
      diffDays = Math.round(diffDays);
      const lastUpdateStr = diffDays > 0 ? `${diffDays} ${daysOrMonths} ago` : 'today';

      return `Last updated ${lastUpdateStr}`
    },
  },
};
</script>

<style lang="scss">
$completeColor: #32b95f;
$activeColor: #3399ff;
.quarter-dropdown {
  a {
    color: unset;
  }
}
.quarter-card {
  width: 23%;
  margin-right: 2%;
  min-height: 80px;
  &.active {
    color: #434343;
    background-color: #e7f0fa;
  }
  &.disabled {
    color: #b8b8b8;
    background-color: #f5f5f5;
  }
}
.dot {
  &.active {
    background-color: $activeColor;
  }
  &.completed {
    background-color: $completeColor;
  }
}
.card-label {
  font-size: 10px;
  text-align: right;
  padding-top: 2px;
}
</style>
